// extracted by mini-css-extract-plugin
export default {"main":"TabHeaders_main__j+ANE","icon":"TabHeaders_icon__x9X+f","icon--inactive":"TabHeaders_icon--inactive__Y5eaE","sortLabel":"TabHeaders_sortLabel__33c15"};